const resources = {
    aiSummaryTitle: 'Résumé des avis par l’IA',
    aiDisclaimer: 'Ce résumé a été créé à l’aide de l’intelligence artificielle (IA) à partir du texte de récents avis de la clientèle. Veuillez consulter la section « À propos du produit » pour obtenir les renseignements les plus exacts sur le produit.',
    incentivizedNote: 'Certaines personnes ont reçu quelque chose en échange de cette évaluation (essentiel gratuit, paiement, participation à une promotion).',
    prosMentioned: 'Pour mentionnés',
    consMentioned: 'Inconvénients mentionnés',
    noSummaryAvailable: 'Résumé des avis non disponible pour cet article.',
    fromCustomerReviews: 'D’après les évaluations de membres de la clientèle :'
};

export default function getResource(label) {
    return resources[label];
}
